var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.auth.publicId !== _vm.user.publicId)?_c('div',[(_vm.following)?_c('app-button',{on:{"click":_vm.unfollow}},[_vm._v(" Following")]):_c('app-button',{on:{"click":_vm.follow}},[_vm._v(" Follow")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }